import { ArrowLeft, Download } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export default function FilePreview() {
    const [searchParams] = useSearchParams();
    const url = searchParams.get('url');
    const fileName = searchParams.get('name') || 'file';
    const type = searchParams.get('type') || 'file';

    if (!url) {
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-muted-foreground">No file URL provided</p>
            </div>
        );
    }

    const isExcel = ['xlsx', 'xls', 'xlsm', 'xlsb'].some((ext) =>
        fileName.toLowerCase().endsWith(`.${ext}`)
    );

    const isWord = ['docx', 'doc'].some((ext) =>
        fileName.toLowerCase().endsWith(`.${ext}`)
    );

    const isPowerPoint = ['pptx', 'ppt'].some((ext) =>
        fileName.toLowerCase().endsWith(`.${ext}`)
    );

    const isOfficeFile = isExcel || isWord || isPowerPoint;

    // Use Office Online viewer for Office files (all files should come from blob storage)
    const previewUrl = isOfficeFile
        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              url
          )}`
        : url;

    const handleDownload = () => {
        // Create a temporary link to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleBack = () => {
        window.close();
    };

    return (
        <div className="flex flex-col h-screen bg-background">
            {/* Header with download button */}
            <div className="flex items-center justify-between px-4 py-3 border-b bg-card">
                <div className="flex items-center gap-3">
                    <Button
                        variant="ghost"
                        size="compact"
                        onClick={handleBack}
                        className="gap-2"
                    >
                        <ArrowLeft />
                        Luk
                    </Button>
                    <div className="h-6 w-px bg-border" />
                    <div className="flex flex-col">
                        <span className="font-medium text-sm truncate max-w-[300px]">
                            {fileName}
                        </span>
                        <span className="text-xs text-muted-foreground capitalize">
                            {type}
                        </span>
                    </div>
                </div>
                <Button onClick={handleDownload} className="gap-2">
                    <Download />
                    Download
                </Button>
            </div>

            {/* Preview iframe */}
            <div className="flex-1 overflow-hidden">
                <iframe
                    src={previewUrl}
                    className="w-full h-full border-0"
                    title={`Preview: ${fileName}`}
                    allowFullScreen
                />
            </div>
        </div>
    );
}
